import request, { get, post } from '../utils/request';

/** 考试相关 */
export const examination = {
  prefix: `/v1/examination/`,
  /** 创建试卷 */
  create(params: API.examinationCreate) {
    return post<{ token: string }>(`${this.prefix}create`, params);
  },
  /** 用飞书application_id创建试卷 */
  createWithLark(params: API.examinationCreateWithLark) {
    return post<{ token: string }>(`${this.prefix}createWithLark`, params);
  },
  /** 验证试卷有效性 */
  verify(params: { token: string }) {
    return get<API.examinationVerify>(`${this.prefix}verify`, params);
  },
  /** 获取试卷的状态, 是否已经提交 */
  submitStatus(params: { examId: string }) {
    return get<{
      submitted: boolean
    }>(`${this.prefix}submitStatus`, params);
  },
  /** 获取考试内容 - 选择题 */
  getContentChoice(params: {
    /** 考试id */
    examId: string;
  }) {
    return get<API.examinationRadioContent>(`${this.prefix}getContent/choice`, params);
  },
  /** 获取考试内容 - 编程题 */
  getContentCode(params: {
    /** 考试id */
    examId: string;
  }) {
    return get<API.examinationCodeContent>(`${this.prefix}getContent/code`, params);
  },
  /** 获取选择题结果 */
  resultChoice(params: { examId: string; }) {
    return get< API.radioProblemResult[]>(`${this.prefix}result/choice`, params);
  },
  /** 获取编程题的结果 */
  resultCode(params: { examId: string; }) {
    return get<API.codeProblemResult[]>(`${this.prefix}result/code`, params);
  },
  /** 提交试卷 */
  submit(params: API.examinationSubmitParams) {
    return post<string>(`${this.prefix}submit`, params);
  },
  /** 获取试卷列表 */
  type() {
    return get<{ typeId: string; typeName: string; }[]>(`${this.prefix}type`);
  },
  /** 获取考生答题列表 */
  list(params: {
    /** limit * 页数的值 */
    sinceId: number;
    /** 考生姓名 */
    candidateName?: string;
    /** hr 姓名 */
    hrName?: string;
    /** 限制每页的数量 */
    limit: number;
    /** 排序类型 score | time */
    type: string;
    /** 升序还是降序 asc | desc */
    sort: string;
  }) {
    return get<API.examinationList>(`${this.prefix}list`, params);
  },
  /** 获取未答题列表 */
  unfinished() {
    return get<API.question[]>(`${this.prefix}unfinished`);
  }
};

export const judge = {
  prefix: `/v1/judge/`,
  /** 提交测试用例 */
  submission(params: API.examinationSubmissionParams) {
    return post<{ submissionId: string; }>(`${this.prefix}submission`, params);
  },
  /** 查看某一提交的测试用例的状态 */
  submissionGet(params: { submissionId: string }) {
    return get<{
      /**  代码实际的执行的输出 */
      actualOutput: string;
      /**  预期应该有的输出 */
      expectedOutput: string;
      /** 错误信息, 只有在 code = 1 的时候才有 */ 
      errorInfo?: string;
    }>(`${this.prefix}submission`, params);
  },
  /** 获取试卷列表 */
  languages() {
    return get<{ languageId: number; languageName: string; }[]>(`${this.prefix}languages`);
  },
};

export const hr = {
  prefix: `/v1/hr/`,
  /** hr 列表 */
  list() {
    return get<{ hrId: string; hrName: string; }[]>(`${this.prefix}list`);
  },
};

export const candidate = {
  prefix: `/v1/candidate/`,
  /** 考生信息 */
  info(params: { candidateId: string }) {
    return get<API.candidateInfo>(`${this.prefix}info`, params);
  },
};


/** 登陆接口 */
export function login(userName: any, userPwd: any) {
  const url = `https://www.233xyx.com/apiserv/api/system/ldap/login?userName=${userName}&password=${userPwd}`;
  return request({
    method: 'POST',
    baseURL: url,
  });
}
